var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    id: "blobSvg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255, 95, 109)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255, 195, 113)"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blob",
    d: "M461,281Q442,312,434.5,345Q427,378,405,405.5Q383,433,351,448Q319,463,284.5,468Q250,473,215.5,467.5Q181,462,144,454.5Q107,447,88,414Q69,381,64,346.5Q59,312,42,281Q25,250,25.5,213.5Q26,177,37.5,140.5Q49,104,80,81Q111,58,143.5,40Q176,22,213,29.5Q250,37,288,27Q326,17,356.5,39Q387,61,418,83Q449,105,456,143Q463,181,471.5,215.5Q480,250,461,281Z",
    fill: "url(#gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob4);
export default __webpack_public_path__ + "static/media/blob4.4142ed3e00ec98e775a932bf7b2ed343.svg";
export { ForwardRef as ReactComponent };